import { DatePipe } from '@angular/common';
import { inject, Pipe, type PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'date',
  pure: false,
})
export class DateFormatPipe implements PipeTransform {
  private readonly _datePipe = inject(DatePipe);
  private readonly _translateService = inject(TranslateService);

  private _defaultDateFormat: string;

  constructor() {
    this._defaultDateFormat =
      this._translateService.instant('_system.dateFormat');
  }

  public transform(value: any, dateFormat?: string): string {
    return this._datePipe.transform(
      value,
      dateFormat || this._defaultDateFormat,
    );
  }
}
